import React from 'react';
import { LocationDescriptorObject, LocationState, Path } from 'history';
import { connect } from 'react-redux';
import { BackButton } from '@lialo/pwa-ui/lib/PageComponents/AppBar';
import { navigationActions } from '@lialo/core/lib/pages/common/navigation';

interface IProps {
  parentUrl: LocationDescriptorObject<LocationState> | Path;
  forceReplace?: boolean;
}

const dispatchProps = {
  goBackOrReplace: navigationActions.goBackOrReplace,
};

type IAllProps = IProps & typeof dispatchProps;

const RouterBackButton = (props: IAllProps) => {
  const onClick = () => {
    props.goBackOrReplace(props.parentUrl, !!props.forceReplace);
  };

  return <BackButton onClick={onClick} />;
};

export default connect(undefined, dispatchProps)(RouterBackButton);
